<div *ngIf="mapGotoBlockContent?.formContent" class="pt-2 pb-1 go-to-container">
  <section class="w-100">
    <div class="accordion" id="goToBlock">
      <div class="filters-card">
        <div class="filters-card-header px-2 py-0" data-test-id="filters-card-header-mapGoto" id="filters-map-goto">
          <h2 class="mb-0">
            <button
              class="btn btn-link fw-bold text-start w-100"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#hideGoTo"
              aria-expanded="true"
              aria-controls="hideGoTo"
            >
              {{ 'MAP_GOTO_BLOCK_FILTERS_HINT' | translate }}
            </button>
          </h2>
        </div>
        <div id="hideGoTo" aria-labelledby="filters" data-parent="#goToBlock">
          <div class="collapse-go-to px-1 h-100">
            <div class="filters-card-body px-2 my-2">
              <app-form-constructor [formContent]="mapGotoBlockContent.formContent"></app-form-constructor>
            </div>
            <div class="text-end p-2 mb-1">
              <button
                class="btn btn-primary"
                type="submit"
                data-test-id="btn-submit-form-map-goto"
                (click)="onSubmitForm($event)"
              >
                {{ 'MAP_GOTO_BLOCK_SEARCH_BUTTON_HINT' | translate }}
              </button>
              <a class="locate-me-btn" data-test-id="locate-me-btn" (click)="onLocateMeBtnClick()">
                {{ 'MAP_GOTO_BLOCK_LOCATE_ME_BTN_HINT' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
